import React, { useState, useEffect } from "react";

// Components
import Main from "./DR/Main";
import Form from "./DR/Form";
import moment from "moment";

import {
  getData,
  getDocStatusColour,
  getAlert,
  getMaxDocNo,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

const DR = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [cachedStatusColours, setCachedStatusColours] = useState(null);
  const [maxDocNo, setMaxDocNo] = useState();
  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem("debitNoteStartDate");
    return (
      storedStartDate ||
      moment().startOf("month").add(543, "year").format("YYYY-MM-DD")
    );
  });

  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem("debitNoteEndDate");
    return (
      storedEndDate ||
      moment().endOf("month").add(543, "year").format("YYYY-MM-DD")
    );
  });

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const convertBEtoAD = (dateStr) => {
    return moment(dateStr, "YYYY-MM-DD").subtract(543, "year").format("YYYY-MM-DD");
  };

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(true);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async (
    updateMaxDocNo = true,
    allDates = false,
    overrideStartDate = null,
    overrideEndDate = null
  ) => {
    try {
      const beStart = overrideStartDate || startDate;
      const beEnd = overrideEndDate || endDate;

      localStorage.setItem("debitNoteStartDate", beStart);
      localStorage.setItem("debitNoteEndDate", beEnd);

      const startAD = convertBEtoAD(beStart);
      const endAD = convertBEtoAD(beEnd);

      const whereClause = allDates
        ? "1=1 ORDER BY Doc_Date DESC, Doc_No DESC"
        : ` Doc_Date >= '${startAD}' AND Doc_Date <= '${endAD}' ORDER BY Doc_Date DESC, Doc_No DESC`;



      const promises = [getData("API_1901_DR_H", whereClause)];

      if (!cachedStatusColours) {
        promises.push(getDocStatusColour("DR", "Doc_Status"));
      }

      if (updateMaxDocNo) {
        promises.push(
          getData(
            "API_1901_DR_H",
            "1=1 ORDER BY Doc_ID DESC OFFSET 0 ROWS FETCH NEXT 1 ROWS ONLY"
          )
        );
      }

      const results = await Promise.all(promises);
      let masterList, docStatusColour, findMaxDocNo;

      if (!cachedStatusColours) {
        [masterList, docStatusColour, findMaxDocNo] = results;
      } else {
        docStatusColour = cachedStatusColours;
        if (updateMaxDocNo) {
          [masterList, findMaxDocNo] = results;
        } else {
          [masterList] = results;
        }
      }

      if (masterList?.length > 0) {
        setDataMasterList(masterList);
      }

      if (docStatusColour?.length > 0) {
        setStatusColours(docStatusColour);
        if (!cachedStatusColours) setCachedStatusColours(docStatusColour);
      }

      if (updateMaxDocNo && findMaxDocNo) {
        const maxDoc = getMaxDocNo(findMaxDocNo, "DR");
        setMaxDocNo(maxDoc);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
    fetchRealtime(true);
  };

  const onRowSelected = (docNo) => {
    setMaxDocNo(docNo);
    setMode("U");
    fetchRealtime(false);
  };

  return (
    <div className="DR">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  statusColours={statusColours}
                  name={"ใบเพิ่มหนี้"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(docNo) => onRowSelected(docNo)}
                  getReport={getReport}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  startDate={startDate}
                  endDate={endDate}
                  fetchRealtime={fetchRealtime}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ใบเพิ่มหนี้"}
                  maxDocNo={maxDocNo}
                  getReport={getReport}
                  setMaxDocNo={setMaxDocNo}
                  setMode={setMode}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DR;
